(() => {
  'use strict';

  const formatter = new Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 4,
    useGrouping: true,
  });

  const modeConfig = {
    liquid: {
      baseUnit: 'ml',
      resultUnit: 'ml',
      resultLabel: 'mg CBD per ml',
      servingLabel: 'mg CBD per label-stated serving',
    },
    unit: {
      baseUnit: ' items',
      resultUnit: 'item',
      resultLabel: 'mg CBD per item',
      servingLabel: 'mg CBD per label-stated serving',
    },
    weight: {
      baseUnit: 'g',
      resultUnit: 'g',
      resultLabel: 'mg CBD per gram',
      servingLabel: 'mg CBD per label-stated serving',
    },
  };

  const asPositiveNumber = (input) => {
    if (!input || input.value.trim() === '') return null;
    const value = Number(input.value);
    return Number.isFinite(value) && value > 0 ? value : null;
  };

  const formatNumber = (value) => formatter.format(Number(value.toFixed(4)));

  const initialiseCalculator = (root) => {
    if (!root || root.dataset.cbhStrengthCalculatorReady === 'true') return;

    const form = root.querySelector('[data-calculator-form]');
    const modeInputs = [...root.querySelectorAll('input[type="radio"]')];
    const panels = [...root.querySelectorAll('[data-mode-panel]')];
    const totalInput = root.querySelector('[data-total-cbd]');
    const result = root.querySelector('[data-calculator-result]');
    const resultMain = root.querySelector('[data-result-main]');
    const resultFormula = root.querySelector('[data-result-formula]');
    const resultServing = root.querySelector('[data-result-serving]');
    const resultServingValue = root.querySelector('[data-result-serving-value]');
    const status = root.querySelector('[data-calculator-status]');

    if (!form || !modeInputs.length || !panels.length || !totalInput || !result) return;

    root.dataset.cbhStrengthCalculatorReady = 'true';

    const currentMode = () => modeInputs.find((input) => input.checked)?.value || 'liquid';

    const hideFeedback = () => {
      status.hidden = true;
      status.textContent = '';
      result.hidden = true;
      resultServing.hidden = true;
      resultMain.textContent = '';
      resultFormula.textContent = '';
      resultServingValue.textContent = '';
    };

    const activateMode = (mode) => {
      panels.forEach((panel) => {
        const active = panel.dataset.modePanel === mode;
        panel.hidden = !active;
        panel.querySelectorAll('input').forEach((input) => {
          input.disabled = !active;
        });
      });
      hideFeedback();
    };

    modeInputs.forEach((input) => {
      input.addEventListener('change', () => activateMode(input.value));
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      hideFeedback();

      const mode = currentMode();
      const panel = panels.find((item) => item.dataset.modePanel === mode);
      const baseInput = panel?.querySelector('[data-base-value]');
      const servingInput = panel?.querySelector('[data-serving-value]');
      const total = asPositiveNumber(totalInput);
      const base = asPositiveNumber(baseInput);
      const optionalServingSupplied = Boolean(servingInput?.value.trim());
      const serving = optionalServingSupplied ? asPositiveNumber(servingInput) : null;

      if (!form.checkValidity() || total === null || base === null || (optionalServingSupplied && serving === null)) {
        status.textContent = 'Enter valid positive figures exactly as they appear on the product label.';
        status.hidden = false;
        form.reportValidity();
        return;
      }

      const config = modeConfig[mode];
      const perBase = total / base;

      resultMain.textContent = `${formatNumber(perBase)} ${config.resultLabel}`;
      resultFormula.textContent = `${formatNumber(total)}mg ÷ ${formatNumber(base)}${config.baseUnit} = ${formatNumber(perBase)}mg per ${config.resultUnit}`;

      if (serving !== null) {
        resultServingValue.textContent = `${formatNumber(perBase * serving)} ${config.servingLabel}`;
        resultServing.hidden = false;
      }

      result.hidden = false;
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      result.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    });

    form.addEventListener('reset', () => {
      window.setTimeout(() => activateMode(currentMode()), 0);
    });

    activateMode(currentMode());
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-cbh-strength-calculator]').forEach(initialiseCalculator);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
